// import { canUseDOM } from 'exenv';

export function tagScrollingModuleLoading(resp = {}, store = {}) {
  return {
    type: 'TAG_SCROLLING_MODULE_LOADING',
    tagScrollingModule: resp,
    store
  };
}

export function tagScrollingModuleLoaded(resp = {}, store = {}) {
  return {
    type: 'TAG_SCROLLING_MODULE_LOADED',
    tagScrollingModule: {
      posts: resp.posts,
      tag: resp.tag
    },
    store
  };
}

export function tagScrollingModuleLoadError(error, store = {}) {
  return {
    type: 'TAG_SCROLLING_MODULE_ERROR',
    tagScrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
